module.exports = __webpack_public_path__ + "img/logo-geo.2bbbf08e.jpeg";